import { render, staticRenderFns } from "./RememberPasswordHampa.vue?vue&type=template&id=6fbde0e3&scoped=true&"
import script from "./RememberPasswordHampa.vue?vue&type=script&lang=js&"
export * from "./RememberPasswordHampa.vue?vue&type=script&lang=js&"
import style0 from "./RememberPasswordHampa.vue?vue&type=style&index=0&id=6fbde0e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbde0e3",
  null
  
)

export default component.exports